import { useCallback } from "react"

import { useParams } from "react-router-dom"

import { useCampaign } from "@l2r-front/l2r-shared-campaign"
import { useNavigateWithSearchParams } from "@l2r-front/l2r-utils"

export const CampaignValidator = (props) => {
    const { children } = props

    const { campaignId } = useParams()
    const navigate = useNavigateWithSearchParams()

    const navigateBack = useCallback(() => {
        navigate("..")
    }, [navigate])

    const { data: existingCampaign } = useCampaign(campaignId, {}, {
        onError: () => {
            navigateBack()
        },
    })

    if (!existingCampaign) {
        return null
    }

    return children
}